import {prepareSummaryState} from "@components/SummarySelection/data/selectors";
import {Record} from "immutable";

export const IQ_INITIAL_STATE = {
    name: "",
    category_id: null,
    package_id: null,
    recalculate: false,
    recalculate_queue: [],
    options: [],
    prices: [],
    order: {
        name: "",
        items: [],
    },
};

export const instantQuoteReducer = (state = IQ_INITIAL_STATE, action) => {
    switch (action.type) {
        case "updateSummary":
            const {items} = prepareSummaryState(action.payload);
            const payload = Record.isRecord(action.payload) ? action.payload.toJS() : action.payload;
            return {
                ...state,
                package_id: payload.package_id,
                package: payload.package,
                skus_ids: payload.skus_ids,
                skus: payload.skus,
                package_skus: payload.package_skus,

                order: {
                    ...state.order,
                    items,
                },
            };
        case "setOrderPrice":
            return {
                ...state,
                orderPrice: action.payload,
            };
        case "setOrderPriceLoading":
            return {
                ...state,
                orderPriceLoading: action.payload,
            };
        case "setCategory":
            return {
                ...state,
                category_id: action.payload,
            };
        case "setCategoryObject":
            return {
                ...state,
                category: action.payload,
            };
        case "setPackage":
            return {
                ...state,
                package_id: action.payload,
            };
        case "setOptions":
            return {
                ...state,
                options: action.payload,
            };
        case "recalculate":
            return {
                ...state,
                recalculate: true,
                recalculate_queue: [...state.recalculate_queue, action.payload],
            };
        case "recalculateIsDone":
            return {
                ...state,
                recalculate: false,
                recalculate_queue: [],
                prices: action.payload,
            };
        case "setOrder":
            return {
                ...state,
                order: action.payload,
            };
        case "createOrder":
            return {
                ...state,
                creatingOrder: true,
                order: action.payload,
            };
        case "orderIsCreated":
            return {
                ...state,
                creatingOrder: false,
            };
        default:
            return state;
    }
};
